export const worldMap = {
  reset: "إعادة تعيين",
  resetMapSelections: "إعادة اختيار الخريطة",
  zoomIn: "إجعلها أكبر",
  zoomOut: "اجعلها أصغر",
  indicatorPanel: {
    indicatorPanelTitle: "الوضع الحالي للصحة الرقمية في جميع أنحاء العالم",
    noHealthIndicatorAvailable: "لا توجد مؤشرات صحية عالمية متاحة",
    noDigitalIndicatorAvailable: "لا توجد مؤشرات الصحة الرقمية المتاحة",
    viewCountries: "عرض البلدان",
    viewDetails: "عرض التفاصيل",
    context: {
      text: "السياق",
      gniPerCapita:
        "الدخل القومي الإجمالي للفرد، طريقة أطلس (بالأسعار الجارية للدولار الأمريكي)",
      totalPopulation: "العدد الإجمالي للسكان",
      adultLiteracyRate:
        "معدل معرفة القراءة والكتابة لدى البالغين، السكان الذين تزيد أعمارهم عن 15 عامًا، كلا الجنسين (٪)",
      easeOfDoingBusinessIndex: "مؤشر سهولة ممارسة الأعمال",
    },
    health: {
      text: "الصحة",
      lifeExpectancy: "العمر المتوقع عند الولادة (بالسنوات)",
      healthExpenditure: "الإنفاق على الصحة (٪ من إجمالي الناتج المحلي)",
      causeOfDeath: "سبب الوفاة، بسبب الأمراض غير المعدية (٪ من الإجمالي)",
      mortalityRate: "معدل الوفيات، دون الخامسة (لكل 1000 ولادة حية)",
    },
    description:
      "مراقب الصحة الرقمية العالمية (GDHM) هو مورد تفاعلي متاح عبر الانترنت يهدف إلى تتبع ومراقبة وتقييم البيئة التمكينية للصحة الرقمية في جميع أنحاء العالم.",
  },
  searchCountry: "بحث البلد",
  note: "مصنوع من Natural Earth.",
  note1: "حدود الهند",
  note2: "بواسطة",
  note3: "مجتمع DataMeet India",
};
